import React, { Component } from 'react';

class SchedulesMetadata extends Component {
    render() {
        return (
            <div>
                <h2> Página de Horários </h2>
                <p>
                    Nesta página encontra todos os horários disponíveis no operador de acordo com os tipos de dia a que funciona e a edição à que pertence.
                </p>
                <h3>Funcionalidades disponíveis</h3>
                <ul className="bulleted-list">
                    <li>Criar horários na rede ativa e na de rascunho</li>
                    <li>Editar horários na rede ativa e na de rascunho</li>
                    <li>Eliminar horários na rede ativa e na de rascunho</li>
                    <li>Pesquisar os horários disponíveis na rede ativa e na rede de rascunho</li>
                    <li>Comparar os horários da rede ativa com os horários da rede de rascunho </li>
                </ul>
            </div>
        );
    }
}

export default SchedulesMetadata;


// WEBPACK FOOTER //
// ./src/components/metadata/datamanager/SchedulesMetadata.js